import DefaultList from '../List';


function wrapSinglePageResponse(items) {
    const response = {
        items,
        data: { items },
        hasNextPage: false,
        isFirstPage: true,
        nextPage: () => undefined,
        next: async () => ({ done: true, value: undefined }),
    };
    response[Symbol.asyncIterator] = async function* () {
        yield response;
    };
    return response;
}

export default class SyncConfigsAuditList extends DefaultList {
    async list() {
        const { endpoint, parentEntity } = this.props;
        const resp = await endpoint.getAuditLogs(parentEntity.entityId);
        const items = resp.data.items || resp.data || [];

        return wrapSinglePageResponse(items);
    }
}
